<template>
  <vue-final-modal v-model="state" classes="modal-container" content-class="modal-content" :close-on-esc="false" :click-outside-to-close="false">
      <span class="modal__title">Reminder</span>
      <div class="modal__content mt-3 mb-4">
        Auto phishing has not been configured for your organisation. Please complete your set up to begin test phishing campaigns.
      </div>
      <div class="modal__action">
        <div>
          <button type="button" class="btn btn-outline-primary" @click="redirectToPhishing">Continue</button>
        </div>

        <div>
          <button type="button" class="btn btn-outline-danger" @click="closeDialog">Skip</button>
          <button type="button" class="btn btn-outline-danger ms-2" @click="disableReminder">Don't Ask Again</button>
        </div>
      </div>
    </vue-final-modal>
</template>

<script>
export default {
  name: "PhishingReminder",
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      state: this.dialog,
    };
  },

  watch: {
    dialog(newVal) {
      this.state = newVal;
    },
  },

  methods: {
    closeDialog() {
      this.$emit("close");
      this.state = false;
    },

    redirectToPhishing() {
      this.$emit("redirect");
      this.state = false;
    },

    disableReminder() {
      this.$emit("neverAsk");
      this.state = false;
    },
  },
};
</script>

<style scoped>
:deep(.modal-container) {
  display: flex;
  justify-content: center;
  align-items: center;
}

:deep(.modal-content) {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 90%;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff !important;
  width: 30% !important;
}
.modal__title {
  margin: 0 2rem 0 0;
  font-size: 1.2rem;
  font-weight: 700;
}
.modal__content {
  flex-grow: 1;
  overflow-y: auto;
}
.modal__action {
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;
  padding: 1rem 0 0;
}

@media screen and (max-width: 900px) {
:deep(.modal-content) {
  width: 95%;
}
}

</style>
